// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"399c2c28","842":"5b3b4fd8"}[chunkId] + ".chunk.js";
};